// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import pt from 'prop-types';
import cx from 'classnames';

import { MrCard } from '@ion/components';
import { Typography } from '@metarouter-private/mr-mui';

import s from '../index.module.scss';

const GeneralCard = ({ title, className, ...props }) => {
  return (
    <MrCard
      className={cx(s.card, className)}
      top={
        <div className={s.header}>
          <Typography variant="h3">{title}</Typography>
        </div>
      }
      {...props}
    />
  );
};
GeneralCard.propTypes = {
  icon: pt.string,
  title: pt.string,
  className: pt.string,
};

export default GeneralCard;
